import React, {FC, memo} from "react";
// import { Form } from '@ant-design/compatible';
// import '@ant-design/compatible/assets/index.css';
import {Form} from "antd";
import {FormItemProps} from "antd/lib/form";
import {TimePickerProps} from "antd/lib/time-picker";
import moment from "moment";
import classnames from "classnames";
import css from "./CourseTimeInput.less";
import {ISODateString} from "../../helpers/typeScriptHelpers";
import CustomTimeInput from "../../containers/common/CustomTimeInput";

type CourseTimeInputProps = Pick<
    FormItemProps,
    "validateStatus" | "help" | "label"
> &
    Pick<TimePickerProps, "onChange" | "placeholder"> & {
        isGreyedOut?: boolean;
        style?: React.CSSProperties;
        testId?: string;
        value?: ISODateString;
    };

const CourseTimeInput: FC<CourseTimeInputProps> = ({
    label,
    placeholder,
    testId,
    validateStatus,
    help,
    value,
    onChange,
    isGreyedOut,
    ...props
}) => {
    return (
        <div
            className={classnames(css.root, {[css.isGreyedOut]: isGreyedOut})}
            data-testid={testId}
            {...props}
        >
            <Form.Item
                label={label}
                validateStatus={validateStatus}
                help={help}
                required
            >
                <CustomTimeInput
                    value={moment(value)}
                    onChange={(value) => {
                        if (onChange && value) {
                            onChange(value, value.format("HH:mm"));
                        }
                    }}
                    status={
                        validateStatus === "error" ||
                        validateStatus === "warning"
                            ? validateStatus
                            : undefined
                    }
                    className={
                        validateStatus === "error" ? css.inputError : undefined
                    }
                />
            </Form.Item>
        </div>
    );
};

export default memo(CourseTimeInput);
